export const CategoryLabels = {
    'Foldtaniobjektum': 'Földtani objektum',
    'Asvanyviz': 'Ásványvíz',
};

export const KeyLabels = {
    'Kofejto': 'Kőfejtő',
    'Banya': 'Bánya',
    'Bezartbanya': 'Bezárt bánya',
    'Olajesgaz': 'Olaj és gáz',
    'Kilato': 'Kilátó',
    'Iszapvulkan': 'Iszapvulkán',
    'Borviz': 'Borvíz',
    'Forras': 'Forrás',
    'Mofetta': 'Mofetta',
    'Radioaktiv': 'Radioaktív víz',
    'Kenes': 'Kénes szulfátos víz',
};

export const categories = {
    'Foldtaniobjektum': ['Kofejto', 'Banya', 'Bezartbanya', 'Olajesgaz', 'Kilato', 'Iszapvulkan'],
    'Asvanyviz': ['Borviz', 'Forras', 'Mofetta', 'Radioaktiv', 'Kenes'],
};

export const admlayers = {
    'helynev': 'helynev',
    'megye': 'megye',
    'szek': 'szek',
    'kozsegvaros': 'kozsegvaros',
    'telepules': 'telepules',
};

export const gsst_admlayers = {
    'megye': 'megye',
    'szek': 'szek',
    'kozsegvaros': 'kozsegvaros',
};

export const AdmLabels = {
    'kozsegvaros': 'Község, város',
    'telepules': 'Település',
    'szek': 'Szék',
    'megye': 'Megye',
    'helynev': 'Helynév',
};
